export const HOME_PATH = '/'
export const PRODUCTS_PATH = '/products'
export const PRODUCT_PATH = '/product'
export const PRODUCTS_LINE_PATH =  PRODUCTS_PATH + '/line'
export const ID_PRODUCTS_LINE_PATH =  PRODUCTS_LINE_PATH + '/:id'
export const PRODUCT_DETAIL_PATH =  PRODUCT_PATH + '/detail'
export const ID_PRODUCT_DETAIL_PATH =  PRODUCT_DETAIL_PATH + '/:id'
export const PRODUCTS_CATEGORIES_PATH = PRODUCTS_PATH + '/categories'
export const LOGIN_PATH = '/login'
export const LOGOUT_PATH = '/logout'
export const PASSWORD_RESET_PATH = '/password-reset'
export const ORDERS_PATH = '/orders'
export const ORDERS_HISTORY_PATH = ORDERS_PATH + '/history'
export const ORDERS_MANAGEMENT_PATH = ORDERS_PATH + '/management'
export const ORDERS_STATUS_PATH = ORDERS_MANAGEMENT_PATH + '/status'
export const TICKETS_PATH = '/tickets'
export const ORDER_DETAIL_PATH = ORDERS_PATH + '/detail' + '/:id'
export const CART_PATH = '/checkout'
export const CHECKING_ACCOUNT_PATH = '/checking-account'
export const PROFILE_PATH = '/profile'
export const SEARCH_PATH = '/search'
export const SEARCH_ARTICLES_PATH = SEARCH_PATH + '/:articleOrCategoryName'